import Search from '@/src/components/Antd/Search/Search';
import { useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { get } from 'lodash';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { EInclude } from 'src/constrains/AdvancedFilters/Components/CommonRadioMulSelect';
import { ESubscribed } from 'src/constrains/AdvancedFilters/Components/RegisteredStatus';
import Trigger from 'src/constrains/Query1/Filter/DropDown/Trigger';
import { useI18n } from 'src/hooks/useRouterChange';
import { CustomerListCommonContext } from 'src/pages/CustomerDatabaseConfig/CustomerList';
import GlobalTable from 'src/pages/CustomerDatabaseConfig/CustomerList/Components/CommonTable/BulkEditorTable2';
import {
  subscriberListPage,
  subscriberListSearch,
} from 'src/request/customer/list';
import { defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { i18nGet } from 'src/tools/tools';
import { ESort } from 'src/types/common';
import Filter from '../AdvancedFilter';
import css from './css.module.less';
import { useCols } from './tools';
const SubscriberTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setExportConfig } = React.useContext(CustomerListCommonContext);
  const h = useHistory();
  const { id, disabled } = props;

  const defaultCol = React.useRef<any>([]);
  const [filterData, setFilterData] = React.useState<any>({});
  const [filter, setFilter] = React.useState<any>({});
  const [filterDisplay, setFilterDisplay] = React.useState(false);
  const [search, setSearch] = React.useState('');
  /* 分页 */
  const [current, setCurrent] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { customerDatabaseUuid }: any = useParams();
  const [loaded, setLoaded] = React.useState(false);
  const [columns, setColumns] = React.useState([]);

  // const [sort, setSort] = React.useState({});
  const [data, setData] = React.useState([]);

  const filterTransfer = () => {
    const {
      consentAttributeFilter,
      registeredSalesChannelFilter,
      registrationStatusFilter,
    } = filter;

    const { registrationStatus } = registrationStatusFilter || {};
    const { selectedSalesChannelUuids, policy } =
      registeredSalesChannelFilter || {};
    const { include, selectedConsentAttributes } = consentAttributeFilter || {};
    const _consentAttributeFilter = () => {
      if (!include) {
        return {};
      }
      if (include === EInclude.any) {
        return {
          apply: 'AnyOf',
          selectedConsentAttributes,
        };
      }
      if (include === EInclude.all) {
        return {
          apply: 'AllOf ',
          selectedConsentAttributes,
        };
      }
    };
    const _registrationStatus = () => {
      if (!registrationStatus) {
        return null;
      }
      if (registrationStatus === ESubscribed.YES) {
        return true;
      }
      if (registrationStatus === ESubscribed.NO) {
        return false;
      }
    };
    const _registeredSalesChannels = () => {
      if (!policy) {
        return null;
      }
      return { policy, selectedSalesChannelUuids };
    };
    return {
      consentAttributeFilter: _consentAttributeFilter(),
      registrationStatus: _registrationStatus(),
      salesChannelFilter: _registeredSalesChannels(),
    };
  };
  const filtersGenerator = React.useMemo(() => {
    const hasSort = columns.find((i) => i.sortOrder);
    const sort: any = {};
    if (hasSort) {
      const { key, sortOrder } = hasSort;
      if (sortOrder === ESort.asc) {
        sort.field = key;
        sort.ascent = true;
      } else {
        sort.field = key;
        sort.ascent = false;
      }
    }

    return {
      searchText: [search || ''],
      customerDatabaseUuid,
      sort,
      ...filterTransfer(),
    };
  }, [columns, filter, search]);
  const body = filtersGenerator || {};

  const getData = () => {
    return subscriberListSearch(current, pageSize, body).then((res: any) => {
      //console.log(res);
      const { results = [] } = res;
      setData(results);
      setTotal(results.length);
    });
  };
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    // setMappedSelectedKeys,
    // //mappedSelectedKeys,
    // setSelectedRowKeys,
  } = useSelectRows(data);

  const currentUuids = React.useMemo(() => {
    return data.map((i) => i.uuid);
  }, [data]);

  React.useEffect(() => {
    if (setExportConfig) {
      setExportConfig({
        selectAll: selectedAll,
        currentPageUuids: currentUuids,
        selectedUuids: selectedRowKeys,
      });
    }
  }, [selectedRowKeys, selectedAll, currentUuids]);

  useAfterDidMountEffect(() => {
    if (!disabled) {
      getData();
    }
  }, [current]);
  // useAfterDidMountEffect(() => {
  // setCurrent(0);
  // }, [search ]);

  useAfterDidMountEffect(() => {
    if (!disabled) {
      if (!current) {
        getData();
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, body]);

  const handleOnSortChange = (pagination, filters, sorter, extra) => {
    const { columnKey, order } = sorter;
    const _col = columns.map((i) => {
      const re = { ...i };
      if (re.key === columnKey) {
        re.sortOrder = order;
      } else {
        re.sortOrder = '';
      }
      return re;
    });

    setColumns(_col);
  };
  // const _colInSort = React.useMemo(() => {
  // return columns.map(i=>{
  // const { sortOrder, key } = i;
  // })
  // }, [columns]);

  // const sortCondition = React.useMemo(() => {
  // const hasSort = columns.find((i) => i.sortOrder);
  // if (hasSort) {
  // const { sortOrder, key } = hasSort || {};
  // return { order_by: key, order: sortOrder };
  // }
  // return null;
  // }, [columns]);

  // const handleOnColChange = (cols) => {
  // const _col = (cols || []).map((col) => {
  // const _c = { ...(col || {}) };
  // if (!_c.default) {
  // _c.sortOrder = '';
  // }
  // return _c;
  // });
  // setColumns(_col);
  // };

  React.useEffect(() => {
    if (!disabled) {
      subscriberListPage(current, pageSize, body)
        .then((res) => {
          const data = get(res, 'subscribers.results') || [];
          setData(data);
          const total = get(res, 'subscribers.totalCount') || [];
          setTotal(total);
          const f = get(res, 'fields') || [];
          const onView = (uuid) => {
            h.push(
              `/customerDatabase/customerDetail/${customerDatabaseUuid}/${uuid}?type=Subscriber`,
            );
          };
          const col = useCols(f, onView, { getI18n });
          setColumns(col);
          defaultCol.current = col;
          const salesChannels = get(res, 'salesChannels') || [];
          const consentAttributes = get(res, 'consentAttributes') || [];
          setFilterData({
            salesChannels: salesChannels.map((i) => {
              const { name, uuid } = i;
              return { label: name, value: uuid };
            }),
            consentAttributes: consentAttributes.map((i) => {
              return { label: i, value: i };
            }),
          });
          //
        })

        .then(() => {
          setLoaded(true);
        });
    } else {
      setLoaded(true);
    }
  }, []);

  return (
    <React.Fragment>
      <Filter
        display={filterDisplay}
        setDisplay={setFilterDisplay}
        onConfirm={setFilter}
        isSub
        fieldsData={filterData}
      />
      <div className={css.topContainer}>
        <Search
          enterButton='Search'
          onSearch={setSearch}
          allowClear
          placeholder='Search customer'
          formClassName={css.search}
        />
        <div className={css.filterText}>Filter</div>
        <Trigger
          name={'All Filters'}
          hideArrow
          className={css.allFilterTriggers}
          onClick={() => setFilterDisplay(true)}
        />
      </div>
      {loaded && (
        <GlobalTable
          onColChange={setColumns}
          hideBulkEditor
          id={id}
          showSorterTooltip={false}
          onChange={handleOnSortChange}
          hideQuery
          dataSource={data}
          columns={columns}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          rowKey='uuid'
          pagination={paginationProps}
          current={current}
          setCurrent={setCurrent}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
          rowSelection={rowSelection}
          selectedRowKeys={selectedRowKeys}
          // mappedSelectedKeys={mappedSelectedKeys}
          hidePagination={total == 0}
          loading={!loaded}
          className={css.table123}
          defaultCol={defaultCol.current}
          // handleTableSettingChange={handleTableSettingChange}
          // tableSettings={tableSettings}
        />
      )}
    </React.Fragment>
  );
};
export default SubscriberTable;
